const DESKTOP_MENU = '(min-width: 750px)';

function enhanceHeaderMenu(menu) {
  if (menu.dataset.midwestPersistentMenu === 'true') return;
  menu.dataset.midwestPersistentMenu = 'true';

  const applyOsmoSubmenuLogo = () => {
    const osmoLogoUrl = window.MidwestHeaderAssets?.osmoLogoUrl;
    if (!osmoLogoUrl) return;

    menu.querySelectorAll('.menu-list__list-item').forEach((item) => {
      const parentLink = item.querySelector(':scope > .menu-list__trigger a[href], :scope > a[href]');
      const submenu = item.querySelector(':scope > .menu-list__submenu, :scope > [ref="submenu[]"]');
      if (parentLink?.textContent.trim().toLowerCase() !== 'osmo' || !submenu) return;

      const logo = submenu.querySelector('img');
      if (!logo || logo.dataset.midwestOsmoLogo === 'true') return;
      logo.dataset.midwestOsmoLogo = 'true';
      logo.classList.add('mw-osmo-submenu-logo');
      logo.src = osmoLogoUrl;
      logo.removeAttribute('srcset');
      logo.removeAttribute('sizes');
      logo.alt = 'Osmo';
    });
  };

  applyOsmoSubmenuLogo();
  new MutationObserver(applyOsmoSubmenuLogo).observe(menu, { childList: true, subtree: true });

  // The Shopify menu uses /collections for both Shop and Brands. Give each
  // desktop/mobile parent its own useful landing page without changing the
  // store-wide navigation resource used by the currently published theme.
  menu.querySelectorAll('.menu-list__list-item').forEach((item) => {
    const parentLink = item.querySelector(':scope > .menu-list__trigger a[href], :scope > a[href]');
    if (!parentLink) return;

    const label = parentLink.textContent.trim().toLowerCase();
    if (label === 'shop') parentLink.href = '/collections/all';
    if (label === 'brands') parentLink.href = '/collections';
  });

  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
  menu.querySelectorAll('.menu-list__link').forEach((link) => {
    const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    if (linkPath === currentPath) link.dataset.midwestCurrent = 'true';
  });

  const originalDeactivate = menu.deactivate.bind(menu);
  menu.deactivate = (event) => {
    const lockedItem = menu.querySelector('.menu-list__list-item[data-midwest-menu-locked="true"]');
    if (lockedItem && event?.type === 'pointerleave') return;
    originalDeactivate(event);
  };

  const unlock = () => {
    menu
      .querySelectorAll('.menu-list__list-item[data-midwest-menu-locked="true"]')
      .forEach((item) => delete item.dataset.midwestMenuLocked);
  };

  const closeLockedMenu = () => {
    const lockedItem = menu.querySelector('.menu-list__list-item[data-midwest-menu-locked="true"]');
    const disclosure = lockedItem?.querySelector(':scope > .menu-list__trigger [ref="disclosure[]"]');
    unlock();
    if (disclosure?.getAttribute('aria-expanded') === 'true') {
      menu.toggle({ target: disclosure });
    }
  };

  menu.addEventListener(
    'click',
    (event) => {
      if (!window.matchMedia(DESKTOP_MENU).matches) return;

      const control = event.target.closest('[ref="menuitem"], [ref="disclosure[]"]');
      const link = event.target.closest('a[href]');
      const item = control?.closest('.menu-list__list-item');
      const submenu = item?.querySelector(':scope > [ref="submenu[]"]');
      const disclosure = item?.querySelector(':scope > .menu-list__trigger [ref="disclosure[]"]');
      if (!control || !item || !submenu || !disclosure) return;

      // Parent menu labels are real links. Hover reveals their submenus, while
      // clicking the label should still take visitors to the category page.
      // Only the separate disclosure control pins a submenu open on desktop.
      if (link && !link.matches('[ref="disclosure[]"]')) {
        unlock();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (item.dataset.midwestMenuLocked === 'true') {
        closeLockedMenu();
        return;
      }

      unlock();
      if (disclosure.getAttribute('aria-expanded') !== 'true') {
        menu.toggle({ target: disclosure });
      }
      item.dataset.midwestMenuLocked = 'true';
    },
    true
  );

  menu.addEventListener(
    'pointerenter',
    (event) => {
      if (!window.matchMedia(DESKTOP_MENU).matches) return;
      const lockedItem = menu.querySelector('.menu-list__list-item[data-midwest-menu-locked="true"]');
      const enteredItem = event.target.closest?.('.menu-list__list-item');
      if (lockedItem && enteredItem && enteredItem !== lockedItem) unlock();
    },
    true
  );

  document.addEventListener('pointerdown', (event) => {
    if (!menu.contains(event.target)) closeLockedMenu();
  });

  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) closeLockedMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') unlock();
  });
}

function enhanceAllHeaderMenus() {
  document.querySelectorAll('header-menu').forEach(enhanceHeaderMenu);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceAllHeaderMenus, { once: true });
} else {
  enhanceAllHeaderMenus();
}

document.addEventListener('shopify:section:load', enhanceAllHeaderMenus);

// Shopify can restore the header from the back/forward cache with the compact
// overflow calculation it used while the cart was visible. Re-measure once
// after restoration so links return from “More” when the full row fits again.
window.addEventListener('pageshow', () => {
  window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
});

